import Vue from 'vue';
import Router from 'vue-router';


import HostTop from '@/pages/host/Top';
import ClientTop from '@/pages/client/Top';
import AuthTop from '@/pages/auth/Top';
import AuthSignUp from '@/pages/auth/SignUp';
import AuthVerify from '@/pages/auth/Verify';



Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/:office_id/host',
            name: 'HostTop',
            component: HostTop
        },
        {
            path: '/:office_id',
            name: 'ClientTop',
            component: ClientTop
        },
        {
            path: '/',
            name: 'AuthTop',
            component: AuthTop
        },
        {
            path: '/admin/sign_up',
            name: 'AuthSignUp',
            component: AuthSignUp
        },
        {
            path: '/verify',
            name: 'AuthVerify',
            component: AuthVerify
        },
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js